var _filter, _filter2, _filter3, _circle, _circle2, _circle3, _circle4, _g, _g2, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZodiacWheel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#d4af37",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#f4d03f",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#d4af37",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "copperGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#b87333",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#da8a67",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#b87333",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "redGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#8b0000",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#dc143c",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "cosmicGlow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "outerGlow",
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "textGlow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 390,
    stroke: "url(#goldGradient)",
    strokeWidth: 3,
    fill: "none",
    filter: "url(#outerGlow)",
    opacity: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 385,
    stroke: "url(#goldGradient)",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 360,
    stroke: "url(#goldGradient)",
    strokeWidth: 4,
    fill: "none",
    filter: "url(#cosmicGlow)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 300,
    stroke: "url(#goldGradient)",
    strokeWidth: 2,
    fill: "none",
    filter: "url(#cosmicGlow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#goldGradient)",
    strokeWidth: 2,
    filter: "url(#cosmicGlow)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 40,
    x2: 400,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 700,
    x2: 400,
    y2: 760
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 400,
    x2: 100,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 400,
    x2: 760,
    y2: 400
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#goldGradient)",
    strokeWidth: 1.5,
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 40,
    x2: 400,
    y2: 140,
    transform: "rotate(0 400 400)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 40,
    x2: 400,
    y2: 140,
    transform: "rotate(30 400 400)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 40,
    x2: 400,
    y2: 140,
    transform: "rotate(60 400 400)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 40,
    x2: 400,
    y2: 140,
    transform: "rotate(90 400 400)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 40,
    x2: 400,
    y2: 140,
    transform: "rotate(120 400 400)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 40,
    x2: 400,
    y2: 140,
    transform: "rotate(150 400 400)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 40,
    x2: 400,
    y2: 140,
    transform: "rotate(180 400 400)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 40,
    x2: 400,
    y2: 140,
    transform: "rotate(210 400 400)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 40,
    x2: 400,
    y2: 140,
    transform: "rotate(240 400 400)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 40,
    x2: 400,
    y2: 140,
    transform: "rotate(270 400 400)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 40,
    x2: 400,
    y2: 140,
    transform: "rotate(300 400 400)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 40,
    x2: 400,
    y2: 140,
    transform: "rotate(330 400 400)"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 240,
    stroke: "url(#goldGradient)",
    strokeWidth: 2,
    fill: "none",
    filter: "url(#cosmicGlow)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 180,
    stroke: "url(#copperGradient)",
    strokeWidth: 1.5,
    fill: "none",
    opacity: 0.7
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 120,
    stroke: "url(#goldGradient)",
    strokeWidth: 2,
    fill: "none",
    filter: "url(#cosmicGlow)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 80,
    stroke: "url(#goldGradient)",
    strokeWidth: 2,
    fill: "none",
    filter: "url(#cosmicGlow)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 50,
    stroke: "url(#copperGradient)",
    strokeWidth: 1.5,
    fill: "none"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 25,
    fill: "url(#goldGradient)",
    opacity: 0.4,
    filter: "url(#cosmicGlow)"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 35,
    fill: "rgba(212, 175, 55, 0.2)",
    filter: "url(#cosmicGlow)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "'Noto Sans Tamil', 'Latha', sans-serif",
    fontSize: 16,
    fontWeight: 600,
    fill: "url(#goldGradient)",
    textAnchor: "middle",
    filter: "url(#textGlow)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 85,
    transform: "rotate(0 400 400)"
  }, "\u0BAE\u0BC7\u0BB7\u0BAE\u0BCD"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 85,
    transform: "rotate(30 400 400)"
  }, "\u0BB0\u0BBF\u0BB7\u0BAA\u0BAE\u0BCD"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 85,
    transform: "rotate(60 400 400)"
  }, "\u0BAE\u0BBF\u0BA4\u0BC1\u0BA9\u0BAE\u0BCD"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 85,
    transform: "rotate(90 400 400)"
  }, "\u0B95\u0B9F\u0B95\u0BAE\u0BCD"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 85,
    transform: "rotate(120 400 400)"
  }, "\u0B9A\u0BBF\u0BAE\u0BCD\u0BAE\u0BAE\u0BCD"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 85,
    transform: "rotate(150 400 400)"
  }, "\u0B95\u0BA9\u0BCD\u0BA9\u0BBF"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 85,
    transform: "rotate(180 400 400)"
  }, "\u0BA4\u0BC1\u0BB2\u0BBE\u0BAE\u0BCD"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 85,
    transform: "rotate(210 400 400)"
  }, "\u0BB5\u0BBF\u0BB0\u0BC1\u0B9A\u0BCD\u0B9A\u0BBF\u0B95\u0BAE\u0BCD"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 85,
    transform: "rotate(240 400 400)"
  }, "\u0BA4\u0BA9\u0BC1\u0B9A\u0BC1"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 85,
    transform: "rotate(270 400 400)"
  }, "\u0BAE\u0B95\u0BB0\u0BAE\u0BCD"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 85,
    transform: "rotate(300 400 400)"
  }, "\u0B95\u0BC1\u0BAE\u0BCD\u0BAA\u0BAE\u0BCD"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 85,
    transform: "rotate(330 400 400)"
  }, "\u0BAE\u0BC0\u0BA9\u0BAE\u0BCD"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#goldGradient)",
    fontFamily: "serif",
    fontSize: 24,
    textAnchor: "middle",
    filter: "url(#cosmicGlow)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 175,
    transform: "rotate(0 400 400)"
  }, "\u2648"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 175,
    transform: "rotate(30 400 400)"
  }, "\u2649"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 175,
    transform: "rotate(60 400 400)"
  }, "\u264A"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 175,
    transform: "rotate(90 400 400)"
  }, "\u264B"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 175,
    transform: "rotate(120 400 400)"
  }, "\u264C"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 175,
    transform: "rotate(150 400 400)"
  }, "\u264D"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 175,
    transform: "rotate(180 400 400)"
  }, "\u264E"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 175,
    transform: "rotate(210 400 400)"
  }, "\u264F"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 175,
    transform: "rotate(240 400 400)"
  }, "\u2650"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 175,
    transform: "rotate(270 400 400)"
  }, "\u2651"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 175,
    transform: "rotate(300 400 400)"
  }, "\u2652"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 175,
    transform: "rotate(330 400 400)"
  }, "\u2653"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#copperGradient)",
    fontFamily: "serif",
    fontSize: 18,
    textAnchor: "middle",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 265,
    transform: "rotate(15 400 400)"
  }, "\u2609"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 265,
    transform: "rotate(75 400 400)"
  }, "\u263D"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 265,
    transform: "rotate(135 400 400)"
  }, "\u2642"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 265,
    transform: "rotate(195 400 400)"
  }, "\u263F"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 265,
    transform: "rotate(255 400 400)"
  }, "\u2643"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 265,
    transform: "rotate(315 400 400)"
  }, "\u2640"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#goldGradient)",
    fontSize: 14,
    textAnchor: "middle",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 320,
    transform: "rotate(0 400 400)"
  }, "\u2644"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 320,
    transform: "rotate(40 400 400)"
  }, "\u260A"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 320,
    transform: "rotate(80 400 400)"
  }, "\u260B"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 320,
    transform: "rotate(120 400 400)"
  }, "\u2609"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 320,
    transform: "rotate(160 400 400)"
  }, "\u263D"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 320,
    transform: "rotate(200 400 400)"
  }, "\u2642"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 320,
    transform: "rotate(240 400 400)"
  }, "\u263F"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 320,
    transform: "rotate(280 400 400)"
  }, "\u2643"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 320,
    transform: "rotate(320 400 400)"
  }, "\u2640"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#goldGradient)",
    opacity: 0.9,
    filter: "url(#cosmicGlow)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "400,25 404,38 418,38 407,47 411,60 400,52 389,60 393,47 382,38 396,38"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "775,400 762,404 762,418 753,407 740,411 748,400 740,389 753,393 762,382 762,396"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400,775 404,762 418,762 407,753 411,740 400,748 389,740 393,753 382,762 396,762"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25,400 38,404 38,418 47,407 60,411 52,400 60,389 47,393 38,382 38,396"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#goldGradient)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 30,
    r: 3,
    transform: "rotate(0 400 400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 30,
    r: 3,
    transform: "rotate(30 400 400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 30,
    r: 3,
    transform: "rotate(60 400 400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 30,
    r: 3,
    transform: "rotate(90 400 400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 30,
    r: 3,
    transform: "rotate(120 400 400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 30,
    r: 3,
    transform: "rotate(150 400 400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 30,
    r: 3,
    transform: "rotate(180 400 400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 30,
    r: 3,
    transform: "rotate(210 400 400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 30,
    r: 3,
    transform: "rotate(240 400 400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 30,
    r: 3,
    transform: "rotate(270 400 400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 30,
    r: 3,
    transform: "rotate(300 400 400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 30,
    r: 3,
    transform: "rotate(330 400 400)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZodiacWheel);
export default __webpack_public_path__ + "static/media/zodiac-wheel.4f1a69be56a98421df6780dabbec28fd.svg";
export { ForwardRef as ReactComponent };